import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LoaderService } from 'src/app/core/loader-services/loader.service';
import { ValidateExternalLoginCallbackRequest } from 'src/app/core/models/LoginRequest';
import { MembershipService } from 'src/app/membership/membership/membership.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ExternalMemberData } from 'src/app/core/models/local/ExternalMembershipData';

export function buildExternalLoginCallbackRequest(
  queryParams: ParamMap,
  storedMembershipCode: string | null
): ValidateExternalLoginCallbackRequest {
  let membershipCode = queryParams.get('membershipCode')
    ?? queryParams.get('membershipcode')
    ?? storedMembershipCode;
  let payload = queryParams.get('payload');

  // Some external providers return "?payload=" instead of "&payload=".
  // Angular then treats the payload as part of the membershipCode value.
  const embeddedPayloadMarker = '?payload=';
  const embeddedPayloadIndex = membershipCode?.indexOf(embeddedPayloadMarker) ?? -1;

  if (membershipCode && embeddedPayloadIndex >= 0) {
    payload = payload ?? membershipCode.substring(embeddedPayloadIndex + embeddedPayloadMarker.length);
    membershipCode = membershipCode.substring(0, embeddedPayloadIndex);
  }

  return {
    membershipCode: membershipCode ?? null,
    payload: payload ?? null
  };
}

@Component({
  selector: 'app-external-membership-callback',
  template: ''
})
export class ExternalMembershipCallbackComponent implements OnInit {

  constructor(
    private loaderService: LoaderService,
    private membershipService: MembershipService,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  async ngOnInit(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    try {
      this.loaderService.isManualLoad$.next(true);

      const loginReq = buildExternalLoginCallbackRequest(
        this.route.snapshot.queryParamMap,
        localStorage.getItem('membershipcode')
      );

      const response = await this.membershipService.validateexternallogincallback(loginReq);

      if (response?.success && response?.redirectUrl) {
        const externalMemberData = {
          membershipCode: response.data?.membershipCode,
          membershipDetailResponse: response.data
        } as ExternalMemberData;

        this.membershipService.saveExternalMembershipData(externalMemberData);
        window.location.href = response.redirectUrl;
      } else {
        this.membershipService.removeExternalMembershipData(loginReq.membershipCode);

        const errorObj = response?.error || response;
        const errorMessage = errorObj?.errorData?.[0]?.errorMessage || errorObj?.errorMessage || errorObj?.detail || 'An error occurred';

        localStorage.setItem('membershipError', errorMessage);

        const redirectURL = response?.redirectUrl || localStorage.getItem('redirectURL');
        if (redirectURL) {
          window.location.href = redirectURL;
        } else {
          this.router.navigateByUrl('/');
        }
      }
    } finally {
      localStorage.removeItem('membershipcode');
      localStorage.removeItem('redirectURL');
      this.loaderService.isManualLoad$.next(false);
    }
  }

}
